module.exports = __webpack_public_path__ + "img/attacks.f72253f.png";